import React, { useEffect, useState } from 'react';
import {
  MailchimpSignUpFormProps,
  FormData,
} from './mailchimp-sign-up-form.types';
import { MailchimpSignUpFormContainer } from './mailchimp-sign-up-form.styles';

const MailchimpSignUpForm: React.FC<MailchimpSignUpFormProps> = ({
  className,
}) => {
  const [formData, setFormData] = useState<FormData>({});
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    const isCheckbox = (target: EventTarget): target is HTMLInputElement =>
      (target as HTMLInputElement).type === 'checkbox';

    setFormData({
      ...formData,
      [name]: isCheckbox(e.target) ? e.target.checked : value,
    });
  };

  useEffect(() => {
    const successElement = document.getElementById('mce-success-response');

    if (!successElement) return;

    const checkForSuccess = () => {
      if (successElement.style.display !== 'none' && successElement.innerText) {
        setFormData({});
      }
    };

    const observer = new MutationObserver(checkForSuccess);
    const config = { childList: true, subtree: true };
    observer.observe(successElement, config);

    return () => observer.disconnect();
  }, []);

  return (
    <MailchimpSignUpFormContainer>
      <div id="mc_embed_shell" className={className}>
        <div id="mc_embed_signup">
          <form
            action="https://ellenmacarthurfoundation.us7.list-manage.com/subscribe/post?u=bbd27f61161a220e88d7186d4&amp;id=f507e40a10&amp;f_id=009ea2e0f0"
            method="post"
            id="mc-embedded-subscribe-form"
            name="mc-embedded-subscribe-form"
            className="validate"
            target="_blank"
          >
            <div id="mc_embed_signup_scroll">
              <div className="indicates-required">
                <span className="asterisk">*</span> indicates required
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-EMAIL">
                  Business Email <span className="asterisk">*</span>
                </label>
                <input
                  type="email"
                  name="EMAIL"
                  className="required email"
                  id="mce-EMAIL"
                  required
                  value={(formData.EMAIL as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-FNAME">First Name* </label>
                <input
                  type="text"
                  name="FNAME"
                  className=" text"
                  id="mce-FNAME"
                  required
                  value={(formData.FNAME as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-LNAME">Last Name* </label>
                <input
                  type="text"
                  name="LNAME"
                  className=" text"
                  id="mce-LNAME"
                  required
                  value={(formData.LNAME as string) || ''}
                  onChange={handleChange}
                />
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-ROLE">Function / department* </label>
                <select
                  name="ROLE"
                  className=""
                  id="mce-ROLE"
                  value={(formData.ROLE as string) || ''}
                  onChange={handleChange}
                  onBlur={handleChange}
                >
                  <option value=""></option>
                  <option value="Accounting">Accounting</option>
                  <option value="Communications">Communications</option>
                  <option value="Design">Design</option>
                  <option value="Entrepreneur">Entrepreneur</option>
                  <option value="Estate Management">Estate Management</option>
                  <option value="Finance">Finance</option>
                  <option value="Human Resources (HR)">
                    Human Resources (HR)
                  </option>
                  <option value="Information Technology (IT)">
                    Information Technology (IT)
                  </option>
                  <option value="Learning and Development">
                    Learning and Development
                  </option>
                  <option value="Policy-Maker">Policy-Maker</option>
                  <option value="Procurement">Procurement</option>
                  <option value="Product Development">
                    Product Development
                  </option>
                  <option value="Production">Production</option>
                  <option value="Public Affairs">Public Affairs</option>
                  <option value="Research and Development (R&amp;D), Innovation">
                    Research and Development (R&amp;D), Innovation
                  </option>
                  <option value="Sales &amp; Marketing">
                    Sales &amp; Marketing
                  </option>
                  <option value="Strategy, Administrative and Management">
                    Strategy, Administrative and Management
                  </option>
                  <option value="Supply Chain Management">
                    Supply Chain Management
                  </option>
                  <option value="Sustainability and Circular Economy">
                    Sustainability and Circular Economy
                  </option>
                  <option value="University">University</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="mc-field-group">
                <label htmlFor="mce-LEVEL">Seniority* </label>
                <select
                  name="LEVEL"
                  className=""
                  id="mce-LEVEL"
                  value={(formData.LEVEL as string) || ''}
                  onChange={handleChange}
                  onBlur={handleChange}
                >
                  <option value=""></option>
                  <option value="Executive/Senior Leader">
                    Executive/Senior Leader
                  </option>
                  <option value="Director">Director</option>
                  <option value="Mid-Senior">Mid-Senior</option>
                  <option value="Associate">Associate</option>
                  <option value="Entry">Entry</option>
                </select>
              </div>
              <div className="mc-field-group input-group">
                <label htmlFor="mc-group[3652]">Monthly newsletter </label>
                <ul className="checkbox">
                  <li>
                    <label htmlFor="mc-group[3652]-3652-0">
                      Get latest news from across the Foundation to your inbox
                      monthly
                      <input
                        type="checkbox"
                        name="group[3652][1024]"
                        id="mc-group[3652]-3652-0"
                        value="1024"
                        checked={!!formData['group[3652][1024]']}
                        onChange={handleChange}
                      />
                    </label>
                  </li>
                </ul>
              </div>
              <div className="mc-field-group input-group">
                <label htmlFor="mc-group[3631]">Content newsletter </label>
                <ul className="checkbox">
                  <li>
                    <label htmlFor="mce-group[3631]-3631-0">
                      Get our latest videos, podcasts and articles every couple
                      of months
                      <input
                        type="checkbox"
                        name="group[3631][18014398509481984]"
                        id="mce-group[3631]-3631-0"
                        checked={!!formData['group[3631][18014398509481984]']}
                        onChange={handleChange}
                      />
                    </label>
                  </li>
                </ul>
              </div>
              <div className="mc-field-group input-group">
                <label htmlFor="mc-group[3667]">
                  Circular economy updates from North America{' '}
                </label>
                <ul className="checkbox">
                  <li>
                    <input
                      type="checkbox"
                      name="group[3667][4096]"
                      id="mce-group[3667]-3667-0"
                      checked={!!formData['group[3667][4096]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3667]-3667-0">
                      North America Newsletter
                    </label>
                  </li>
                </ul>
              </div>
              <div className="mc-field-group input-group">
                <label htmlFor="mc-group[3576]">
                  Topic-specific (occasional){' '}
                </label>
                <ul className="checkbox">
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][2147483648]"
                      id="mce-group[3576]-3576-0"
                      checked={!!formData['group[3576][2147483648]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-0">Plastics</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][2]"
                      id="mce-group[3576]-3576-1"
                      checked={!!formData['group[3576][2]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-1">Biodiversity</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][4]"
                      id="mce-group[3576]-3576-2"
                      checked={!!formData['group[3576][4]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-2">
                      Built environment
                    </label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][8]"
                      id="mce-group[3576]-3576-3"
                      checked={!!formData['group[3576][8]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-3">
                      Climate change
                    </label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][16]"
                      id="mce-group[3576]-3576-4"
                      checked={!!formData['group[3576][16]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-4">Design</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][128]"
                      id="mce-group[3576]-3576-7"
                      checked={!!formData['group[3576][128]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-7">Fashion</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][256]"
                      id="mce-group[3576]-3576-8"
                      checked={!!formData['group[3576][256]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-8">Finance</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][512]"
                      id="mce-group[3576]-3576-9"
                      checked={!!formData['group[3576][512]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-9">Food</label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][2048]"
                      id="mce-group[3576]-3576-10"
                      checked={!!formData['group[3576][2048]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-10">
                      Supply chain
                    </label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][131072]"
                      id="mce-group[3576]-3576-11"
                      checked={!!formData['group[3576][131072]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-11">
                      Government, policy and cities
                    </label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][16384]"
                      id="mce-group[3576]-3576-12"
                      checked={!!formData['group[3576][16384]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-12">
                      Marketing and communications
                    </label>
                  </li>
                  <li>
                    <input
                      type="checkbox"
                      name="group[3576][1073741824]"
                      id="mce-group[3576]-3576-13"
                      checked={!!formData['group[3576][1073741824]']}
                      onChange={handleChange}
                    />
                    <label htmlFor="mce-group[3576]-3576-13">
                      Circular economy measurement and reporting
                    </label>
                  </li>
                </ul>
              </div>
              <div id="mce-responses" className="clear">
                <div
                  className="response"
                  id="mce-error-response"
                  style={{ display: 'none' }}
                ></div>
                <div
                  className="response"
                  id="mce-success-response"
                  style={{ display: 'none' }}
                ></div>
              </div>
              <div
                aria-hidden="true"
                style={{ position: 'absolute', left: '-5000px' }}
              >
                <input
                  type="text"
                  name="b_bbd27f61161a220e88d7186d4_f507e40a10"
                  tabIndex={-1}
                  value={
                    (formData.b_bbd27f61161a220e88d7186d4_f507e40a10 as string) ||
                    ''
                  }
                  onChange={handleChange}
                />
              </div>
              <div className="clear">
                <input
                  type="submit"
                  name="subscribe"
                  id="mc-embedded-subscribe"
                  className="button"
                  value="Subscribe"
                  gtm-id="newsletter_subscribe"
                />
              </div>
              <div>
                <p className="t-and-c">
                  By clicking subscribe I agree that the Ellen MacArthur
                  Foundation may add me to its email contact list to receive
                  copies of its newsletter and other updates on its work. You
                  can unsubscribe at any time by clicking the link in the footer
                  of our emails.
                </p>
                <p className="t-and-c">
                  The Ellen MacArthur Foundation will process the personal data
                  you have provided in accordance with{' '}
                  <a href="/policies">
                    Ellen MacArthur Foundation's privacy policy
                  </a>
                  . The privacy policy contains more information about how your
                  personal data is used, including how your personal data is
                  shared and your legal rights in respect of your personal data.
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </MailchimpSignUpFormContainer>
  );
};

export default MailchimpSignUpForm;
